import { ActionReducerMap } from '@ngrx/store';
import { reducer as abin } from './abin.reducer';
import { reducer as uppfoljningsrapport } from './uppfoljningsrapport.reducer';
import { InGeApiState } from '../state-model/inge-api.model';

export const reducers: ActionReducerMap<InGeApiState> = {
  abin,
  uppfoljningsrapport,
};
